import { render } from "./VueSelectInput.vue?vue&type=template&id=54db0bfa"
import script from "./VueSelectInput.vue?vue&type=script&lang=js"
export * from "./VueSelectInput.vue?vue&type=script&lang=js"

import "./VueSelectInput.vue?vue&type=style&index=0&id=54db0bfa&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__